<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" :model="searchForm" label-width="80px">
          <el-form-item label="导入编码:">
            <el-input v-model.trim="searchForm.importCode" placeholder="请输入导入编码"></el-input>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
          <el-button class="orange-btn" size="small" @click="handleReset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="handleImport">导入</el-button>
        <el-button type="primary" size="mini" @click="handleExport">导出</el-button>
      </template>
      <el-table
        border
        ref="tableRef"
        :height="maxTableHeight"
        :data="tableData.records"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        v-loading="loading"
      >
        <el-table-column label="产品编码" prop="productCode" min-width="180" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="产品名称" prop="productName" min-width="220" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="金额" prop="saleAmount" min-width="120" align="right"></el-table-column>
      </el-table>
      <template v-slot:footer>
        <div class="footerBox">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin'

export default {
  name: 'ProductSplit',
  mixins: [pagePathMixin, tableMixin],
  data () {
    return {
      loading: false,
      searchForm: {
        importCode: ''
      },
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0
      }
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.loading = true
      const data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          ...this.searchForm
        }
      }
      this.$q.product.jdWoodProductList({ data }).then((res) => {
        if (Number(res.code) === 200 && res.data) {
          this.tableData = res.data
        } else {
          this.tableData.records = []
          this.tableData.total = 0
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch () {
      this.tableData.pageNum = 1
      this.fetchData()
    },
    handleReset () {
      this.searchForm = {
        importCode: ''
      }
      this.tableData.pageNum = 1
      this.tableData.pageSize = 30
      this.fetchData()
    },
    handleSizeChange (val) {
      this.tableData.pageSize = val
      this.tableData.pageNum = 1
      this.fetchData()
    },
    handleCurrentChange (val) {
      this.tableData.pageNum = val
      this.fetchData()
    },
    handleImport () {
      this.openSubPage({
        path: '/productSplitImport',
        query: {
          fileName: '实木商品导入.xlsx',
          appCode: 'ec-pc-api',
          reportName: 'jdWoodGoodsImport'
        }
      })
    },
    handleExport () {
      const params = {
        appCode: 'ec-pc-api',
        paramMap: {
          ...this.searchForm
        },
        reportName: 'jdWoodProductList'
      }
      this.$q.orderDate.importExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！')
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.footerBox
  text-align right

.search-box
  >>> .el-input
    width 240px !important
</style>
